import type { BackupJob } from "./types";

const getHeaders = () => {
  const token = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  return headers;
};

export const fetchBackupJobs = async (): Promise<BackupJob[]> => {
  const res = await fetch("/api/system/backups/", { headers: getHeaders() });
  if (!res.ok) {
    throw new Error(`Failed to fetch backup jobs: HTTP ${res.status}`);
  }
  const data = await res.json();
  if (Array.isArray(data)) {
    return data;
  }
  if (Array.isArray(data.results)) {
    return data.results;
  }
  return [];
};

export const triggerBackup = async (
  type: "Full" | "Incremental" | "Schema-Only" = "Full"
): Promise<{ success: boolean; message: string }> => {
  try {
    const res = await fetch("/api/system/backups/trigger/", {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ type }),
    });
    const data = await res.json();
    if (res.ok) {
      return {
        success: true,
        message: data.message || `Manual ${type} backup triggered successfully.`,
      };
    }
    return {
      success: false,
      message: data.error || data.detail || "Failed to trigger backup.",
    };
  } catch (err: any) {
    return {
      success: false,
      message: err?.message || "Network error while triggering backup.",
    };
  }
};

export const downloadBackupFile = async (id: string, fileName: string): Promise<void> => {
  try {
    const token = localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");
    const headers: Record<string, string> = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;

    const res = await fetch(`/api/system/backups/${id}/download/`, { headers });
    if (!res.ok) {
      alert("Could not download backup file archive from server.");
      return;
    }
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "backup.dump";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Backup download error:", err);
    alert("Network error while downloading backup file.");
  }
};
